import { ArchetypeDefinition } from '../../archetypeTypes';

export const ORDER_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'everyman',
        name: 'Everyman',
        description: 'Balance, typical patterns, and stable participation.',
        category: 'Order',
        tags: ['balance', 'norms', 'stability'],
        weights: { stability: 0.35, nodeCount: 0.25, edgeCount: 0.2, averageNodeEnergy: 0.2 }
    },
    {
        key: 'architect',
        name: 'Architect',
        description: 'Structured design increasing order and efficient connectivity.',
        category: 'Order',
        tags: ['structure', 'design', 'efficiency'],
        weights: { edgeCount: 0.35, fractalDimension: 0.25, stability: 0.25, nodeCount: 0.15 }
    }
];


